import { NavItem } from "@/components/item";
import { CASESTUDIES } from "icons";

export function Casestudies() {

    return (
        <NavItem
            title="Case Studies"
            icon={CASESTUDIES}
            url="/case-studies"
        />
    );
}